import { controlToastState } from "risa-oasis-ui_v2";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";
import {
  TableCellWithImage,
  TableStringWithBadge,
} from "../../../data-model/tableCells";
import { MemberTableColumnKeys } from "../../../enums/tableColumnKeys";
import { ThreeDotIcon } from "../../../svg/three-dot-icon";
import { logError } from "../../../utils/customLogger";
import { FirestoreService } from "./../../../api/firebase/firestoreService";
import { MemberTableData } from "./../../../data-model/tablesData";
import { MemberModel } from "./add-members/add-members";

export const MemberTableHeaderColumns: TableHeader[] = [
  {
    label: "Name",
    key: MemberTableColumnKeys.Name,
    sortable: true,
    order: 1,
    width: 30,
    type: TableCellType.STRING_BADGE,
  },
  {
    label: "Email",
    key: MemberTableColumnKeys.Email,
    sortable: true,
    order: 3,
    width: 25,
    type: TableCellType.STRING,
  },
  {
    label: "Role",
    key: MemberTableColumnKeys.Role,
    sortable: true,
    order: 4,
    width: 15,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: MemberTableColumnKeys.Options,
    sortable: false,
    order: 5,
    width: 15,
    type: TableCellType.ICON,
  },
];

export function generateUIDataForMemberTable(
  member: MemberModel[],
): MemberTableData[] {
  return member.map((member) => {
    const nameWithStatus: TableStringWithBadge = {
      stringText: member.name,
      badgeText: member.status,
    };
    const email: string = member.email;
    const role: string = member.roleId;
    const options: TableCellWithImage =
      member.status !== "Pending"
        ? {
            image: ThreeDotIcon,
            contextMenuItems: [
              {
                label: "Remove",
                onClick: async () => {
                  try {
                    await FirestoreService.updateDocument(
                      FirestoreCollectionReference.providers(),
                      member.id || "",
                      {
                        Status: "disabled",
                      },
                    );
                    controlToastState("member_removed_success");
                  } catch (error: any) {
                    controlToastState("member_removed_failed");
                  }
                },
                color: "#CD0202",
              },
            ],
          }
        : {
            image: ThreeDotIcon,
            contextMenuItems: [
              {
                label: "Resend Invite",
                onClick: async () => {
                  try {
                    await FirestoreService.updateDocument(
                      FirestoreCollectionReference.members(),
                      member.id || "",
                      {
                        status: "reinvited",
                      },
                    );
                    controlToastState("member_reinvite_success");
                  } catch (error: any) {
                    logError(
                      error as Error,
                      "Error while re-inviting the member",
                    );
                    controlToastState("member_reinvite_failed");
                    throw new Error("Error while re-inviting the member");
                  }
                },
              },
              {
                label: "Remove",
                onClick: async () => {
                  try {
                    await FirestoreService.deleteDocument(
                      FirestoreCollectionReference.members(),
                      member.id || "",
                    );
                    controlToastState("member_removed_success");
                  } catch (error: any) {
                    controlToastState("member_removed_failed");
                  }
                },
                color: "#CD0202",
              },
            ],
          };
    return {
      [MemberTableColumnKeys.Name]: nameWithStatus,
      [MemberTableColumnKeys.Email]: email,
      [MemberTableColumnKeys.Role]: role,
      [MemberTableColumnKeys.Options]: options,
    };
  });
}
